<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Proforma {{ numero_documento }}</h3>
        <label>
          <div v-show="estado === 'A'" class="noti-danger">
            <strong>ANULADO</strong>
          </div>
          <div
            v-show="((estado === undefined || estado === null || estado === 'AUT') && facturada === 'N')"
            class="noti-info"
          >
            <strong>EMITIDO</strong>
          </div>
          <div v-show="(facturada === 'S' && estado !== 'A')" class="noti-success">
            <strong>FACTURADA</strong>
          </div>
          <div v-show="estado === 'N'" class="noti-secondary">
            <strong>NUEVO</strong>
          </div>
        </label>
      </div>
      <div class="layout__controls">
        <button @click="consultarComprobantes" class="btn-bus200 btn--bigger" type="button">
          <i class="fa fa-search"></i>
          <span>Buscar proformas</span>
        </button>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__title">
            <h5>Información del comprobante</h5>
          </div>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-4">
                <div
                  :class="{
                                    'select2--disabled' : editando
                                }"
                  class="form-field select2"
                >
                  <div class="form-group">
                    <div class="select2-field">
                      <v-select
                        @input="inputPuntoEmision"
                        label="descripcion"
                        :options="puntosEmision"
                        v-model="selectedPuntoEmision"
                        id="punto_emision"
                        placeholder="Seleccione..."
                      ></v-select>
                      <label for="punto_emision">Punto de emisión *</label>
                      <span
                        v-if="errores.id_punto_emision"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.id_punto_emision[0] }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="datepicker-field">
                    <date-picker
                      :disabled="editando"
                      v-model="form.fecha_emision"
                      type="date"
                      format="dd-MM-yyyy"
                      id="fecha_emision"
                      lang="es"
                    ></date-picker>
                    <label for="fecha_emision">Fecha de emisión *</label>
                    <span
                      v-if="errores.fecha_emision"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.fecha_emision[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select
                      @input="inputVendedor"
                      label="nombre"
                      :options="vendedores"
                      v-model="selectedVendedor"
                      id="vendedor"
                      placeholder="Seleccione..."
                    ></v-select>
                    <label for="vendedor">Vendedor *</label>
                    <span v-if="errores.vendedor_id" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.vendedor_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="multiselect-field">
                    <multiselect
                      @input="inputCliente"
                      :loading="isLoadingCliente"
                      @search-change="onSearchCliente"
                      placeholder="Escriba y seleccione..."
                      :taggable="true"
                      tag-placeholder="Nuevo cliente"
                      label="nombre"
                      track-by="id"
                      @tag="addTag"
                      v-model="selectedCliente"
                      id="cliente"
                      :options="clientes"
                      :preserve-search="true"
                      selectedLabel="Seleccionado"
                      selectLabel="Presiona enter para seleccionar"
                      deselectLabel="Presiona enter para eliminar"
                    >
                      <template slot="noOptions"><span>La lista esta vacía</span></template>
                      <template slot="noResult"><span>No se encontraron elementos. Considere cambiar la consulta de búsqueda.</span></template>
                    </multiselect>
                    <label for="cliente">Cliente *</label>
                    <span
                      v-if="errores.codigo_cliente"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.codigo_cliente[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field id="email" placeholder="Correo del cliente" v-model="form.email">
                    E-mail ("," para separar varios)
                    <span
                      v-if="errores.email"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.email[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div
                v-show="orden_trabajo != null && orden_trabajo !== ''"
                class="col-xs-12 col-md-4"
              >
                <div class="form-field">
                  <div class="form-group">
                    <input-field
                      readonly
                      id="ordenTrabajo"
                      placeholder="OT"
                      v-model="orden_trabajo"
                    >Orden de trabajo</input-field>
                    <button @click="verOrdenTrabajo" class="btn-info btn--text">
                      <i class="fa fa-eye"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field
                    id="observacion"
                    placeholder="Escriba una observación..."
                    v-model="form.observacion"
                  >
                    Observación
                    <span
                      v-if="errores.observacion"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.observacion[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <label for="mostrar_impuestos">
                    <input type="checkbox" name="mostrar_impuestos" id="mostrar_impuestos" v-model="form.mostrar_impuestos"><span>Mostrar valores con impuestos en impresión</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card__title">
            <div class="form-inline">
              <input-field
                id="searchItems"
                v-model="searchItems"
                placeholder="Consulta de detalle por descripción..."
              ></input-field>
              <h5>Items de la proforma</h5>
            </div>            
          </div>
          <div class="card__content">
            <tabla-items-proforma
              :retencionProductos="retencion_productos"
              :retencionServicios="retencion_servicios"
              :errores="errores"
              ref="tablaItems"
              @updated="calcularTotales"
              :irbpnr="irbpnr"
              :tarifas="tarifas"
              v-model="form.detalles"
              :search="searchItems"
            ></tabla-items-proforma>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-xs-12">
            <div class="card">
              <div class="card__title">
                <h5>Forma de pago</h5>
              </div>
              <div class="card__content">
                <tabla-forma-pago
                  :tiposUnidad="tiposUnidad"
                  :totalComprobante="form.total"
                  :errores="errores"
                  :formasPago="formasPago"
                  v-model="form.formasPago"
                ></tabla-forma-pago>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-xs-12 col-md-7">
            <div class="card">
              <div class="card__title">
                <h5>Información adicional</h5>
              </div>
              <div class="card__content">
                <tabla-informacion-adicional
                  enviable
                  :errores="errores"
                  v-model="form.informacionAdicional"
                ></tabla-informacion-adicional>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-5">
            <div class="card">
              <div class="card__title">
                <h5>Totales del comprobante</h5>
              </div>
              <div class="card__content">
                <div class="row">
                  <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.total_sin_impuestos"
                        id="subtotal_sin_impuestos"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        Subtotal S/I
                        <span
                          v-if="errores.total_sin_impuestos"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.total_sin_impuestos[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.descuento_total"
                        id="descuento_total"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        Descuento total
                        <span
                          v-if="errores.descuento_total"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.descuento_total[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.subtotal_no_sujeto_iva"
                        id="subtotal_no_iva"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        Subtotal N/IVA
                        <span
                          v-if="errores.subtotal_no_sujeto_iva"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.subtotal_no_sujeto_iva[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.subtotal_exento_iva"
                        id="subtotal_e_iva"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        Subtotal E/I
                        <span
                          v-if="errores.subtotal_exento_iva"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.subtotal_exento_iva[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.total_irbpnr"
                        id="total_irbpnr"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        Total IRBPNR
                        <span
                          v-if="errores.total_irbpnr"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.total_irbpnr[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.subtotal_iva"
                        id="subtotal_iva"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        Subtotal IVA
                        <span
                          v-if="errores.subtotal_iva"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.subtotal_iva[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.subtotal_iva_0"
                        id="subtotal_iva_0"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        Subtotal IVA 0%
                        <span
                          v-if="errores.subtotal_iva_0"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.subtotal_iva_0[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.iva"
                        id="iva"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        IVA
                        <span v-if="errores.iva" class="helper-text text-danger" slot="helper">
                          <strong>{{ errores.iva[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.ice"
                        id="ice"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        ICE
                        <span v-if="errores.ice" class="helper-text text-danger" slot="helper">
                          <strong>{{ errores.ice[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                    <div class="form-field">
                      <input-field
                        vMoney
                        :format="money"
                        v-model="form.total"
                        id="total"
                        placeholder="$ #,###.##"
                        readonly
                      >
                        Total
                        <span
                          v-if="errores.total"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.total[0] }}</strong>
                        </span>
                      </input-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button
              v-show="estado !== 'A'"
              @click="guardarComprobante"
              type="button"
              class="btn-success"
            >
              <i class="fa fa-save"></i>
              <span>Guardar</span>
            </button>
            <button @click="nuevoComprobante" type="button" class="btn-light btn--text">
              <i class="fa fa-plus"></i>
              <span>Nuevo</span>
            </button>
            <button
              v-show="estado !== 'N' && estado !== 'A'"
              @click="anularComprobante"
              type="button"
              class="btn-danger btn--text"
            >
              <i class="fa fa-ban"></i>
              <span>Anular</span>
            </button>
            <button
              v-show="estado !== 'N'"
              @click="imprimirComprobante"
              type="button"
              class="btn-bus200 btn--text"
            >
              <i class="fa fa-print"></i>
              <span>Imprimir</span>
            </button>
            <button
              v-show="estado !== 'N' && estado !== 'A'"
              class="btn-info btn--text"
              type="button"
              @click="enviarCorreo"
            >
              <i class="fa fa-envelope-o"></i>
              <span>Enviar correo</span>
            </button>
            <button
              v-show="estado !== 'N' && estado !== 'A'"
              class="btn-success btn--text"
              type="button"
              @click="facturar"
            >
              <i class="fa fa-envelope-o"></i>
              <span>Facturar</span>
            </button>
            <button v-show="estado !== 'N' && permiteClonar" @click="clonar" class="btn-primary btn--text">
              <i class="fa fa-clone"></i>
              <span>Clonar</span>
            </button>
            <button
              v-show="estado !== 'N'"
              @click="generarOrdenTrabajo"
              class="btn-warning btn--text"
            >
              <i class="fa fa-briefcase"></i>
              <span>Orden de trabajo</span>
            </button>
            <button
              @click="mostrarAuditorias"
              class="btn-info btn--text"
              type="button"
              v-show="estado !== 'N'"
            >
              <i class="fa fa-file"></i>
              <span>Auditorías</span>
            </button>
            <button
              v-show="estado !== 'N'"
              @click="abrirLogs"
              type="button"
              class="btn-secondary btn--text"
            >
              <i class="fa fa-file-o"></i>
              <span>Logs</span>
            </button>
            <button class="btn-secondary btn--text" type="button" @click="verAnterior">
              <i class="fa fa-toggle-left"></i>
              <span>Anterior</span>
            </button>
            <button class="btn-secondary btn--text" type="button" @click="verSiguiente">
              <i class="fa fa-toggle-right"></i>
              <span>Siguiente</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <modal width="85%" height="auto" scrollable name="listaComprobantes">
      <lista-comprobantes
        :vendedores="vendedores"
        @selected="cargarProforma"
        :tipoComprobante="tipoDocumento"
      ></lista-comprobantes>
    </modal>
    <modal width="50%" name="imprimir" height="auto" scrollable>
      <imprimir :id_comprobante="id_comprobante"></imprimir>
    </modal>
    <modal width="50%" name="auditorias" height="auto" scrollable>
      <auditorias ref="auditorias" @cancelar="cancelarAuditorias" :id_comprobante="id_comprobante"></auditorias>
    </modal>
  </div>
</template>

<script>
export default {
  computed: {
    editando: function() {
      return this.estado !== "N";
    }
  },
  props: {
    permiteClonar: {
      type: Boolean,
      required: false,
      default: false
    },
    idUsuario: {
      type: Number,
      required: false,
      default: -1
    },
    tipoDocumento: {
      type: String,
      required: false,
      default: "00"
    },
    clon: {
      type: Object,
      required: false,
      default: function() {
        return null;
      }
    },
    comprobante: {
      type: Object,
      required: false,
      default: function() {
        return null;
      }
    }
  },
  data: function() {
    return {
      searchItems: '',
      orden_trabajo: "",
      orden_trabajo_id: "",
      clonProforma: this.clon,
      numero_documento: "",
      form: {
        mostrar_impuestos: true,
        fecha_emision: moment(new Date()).format("YYYY-MM-DD"),
        nombre_cliente: "",
        codigo_cliente: "",
        email: "",
        detalles: [],
        informacionAdicional: [
          {
            nombre_campo: "Observación",
            valor_campo: "",
            enviar_sri: true
          },
          {
            nombre_campo: "Concepto",
            valor_campo: "",
            enviar_sri: true
          }
        ],
        id_punto_emision: "",
        vendedor_id: "",
        total_sin_impuestos: 0,
        descuento_total: 0,
        subtotal_no_sujeto_iva: 0,
        subtotal_exento_iva: 0,
        iva: 0,
        subtotal_iva: 0,
        subtotal_iva_0: 0,
        ice: 0,
        total: 0,
        total_irbpnr: 0,
        formasPago: [],
        observacion: ""
      },
      codigoIva: "",
      codigoIce: "",
      id_comprobante: "",
      estado: "N",
      clientes: [],
      clientesTemp: [],
      isLoadingCliente: false,
      puntosEmision: [],
      selectedCliente: null,
      vendedores: [],
      selectedPuntoEmision: null,
      errores: {
        fecha_emision: undefined,
        nombre_cliente: undefined,
        codigo_cliente: undefined,
        detalles: undefined,
        informacionAdicional: undefined,
        id_punto_emision: undefined,
        vendedor_id: undefined
      },
      selectedVendedor: null,
      tarifas: [],
      url: url,
      money: money,
      irbpnr: 0,
      formasPago: [],
      tiposUnidad: [],
      retencion_productos: 0,
      retencion_servicios: 0,
      facturada: "N"
    };
  },
  methods: {
    onSearchCliente: function (search) {
      if (search.length) {
        this.isLoadingCliente = true;
        this.searchingCliente(search, this);
      }
    },
    searchingCliente: _.debounce((search, vm) => {
      fetch(`${url}/personas/search-persona?search=${search}&es_comprobante=true`)
        .then((response) => response.json())
        .then((data) => {
          vm.clientes.splice(0, vm.clientes.length, ...data, ...vm.clientesTemp);
          vm.isLoadingCliente = false;
        });
    }, 350),
    irADocumento: function(tipoProximidad) {
      let that = this;
      axios
        .get(
          url +
            "/comprobantes/" +
            this.tipoDocumento +
            "/" +
            tipoProximidad +
            (this.id_comprobante != null && this.id_comprobante !== ""
              ? "/" + this.id_comprobante
              : "/T")
        )
        .then(function(response) {
          let id = response.data.id;
          if (id === null)
            swal("No hay documento disponible.", "Aviso", "warning");
          else {
            location.href =
              url +
              "/comprobantes?tipo_comprobante=" +
              that.tipoDocumento +
              "&id_comprobante=" +
              id;
          }
        });
    },
    verAnterior: function() {
      this.irADocumento("A");
    },
    verSiguiente: function() {
      this.irADocumento("S");
    },
    verOrdenTrabajo: function() {
      window.open(
        url + "/orden-trabajo/" + this.orden_trabajo_id + "/edit",
        "_blank"
      );
    },
    generarOrdenTrabajo: function() {
      window.open(
        url + "/orden-trabajo/create?proforma=" + this.id_comprobante,
        "_blank"
      );
    },
    cargarProforma: function(proforma) {
      location.href =
        url + "/comprobantes/" + proforma.id_comprobante + "/edit";
    },
    abrirLogs: function() {
      window.open(
        this.url + "/comprobantes/" + this.id_comprobante + "/logs",
        "_blank"
      );
    },
    ponerVendedorDefecto: function() {
      let that = this;
      if (that.vendedores.length > 0) {
        for (let i = 0; i < that.vendedores.length; i++)
          if (that.vendedores[i].id == that.idUsuario) {
            that.selectedVendedor = that.vendedores[i];
            break;
          }
        if (that.selectedVendedor === null)
          that.selectedVendedor = that.vendedores[0];
      }
    },
    cancelarAuditorias: function() {
      this.$modal.hide("auditorias");
    },
    mostrarAuditorias: function() {
      this.$modal.show("auditorias");
    },
    clonar: function() {
      window.open(
        this.url + "/comprobantes/" + this.id_comprobante + "/clonar",
        "_blank"
      );
    },
    facturar: function() {
      window.open(
        this.url + "/comprobantes/" + this.id_comprobante + "/facturar",
        "_blank"
      );
    },
    inputVendedor: function() {
      if (this.selectedVendedor !== undefined && this.selectedVendedor !== null)
        this.form.vendedor_id = this.selectedVendedor.id;
      else this.form.vendedor_id = "";
    },
    inputPuntoEmision: function() {
      let value = this.selectedPuntoEmision;
      if (value !== undefined && value !== null)
        this.form.id_punto_emision = value.id;
      else this.form.id_punto_emision = "";
    },
    inputCliente: function() {
      if (this.selectedCliente !== undefined && this.selectedCliente !== null) {
        this.form.codigo_cliente = this.selectedCliente.id;
        this.form.nombre_cliente = this.selectedCliente.nombre;
        this.form.email = this.selectedCliente.email;
      } else {
        this.form.codigo_cliente = "";
        this.form.nombre_cliente = "";
        this.form.email = '';
      }
    },
    calcularTotales: function() {
      let irbpnr = 0;
      let totalSinImpuestos = 0;
      let iva = 0;
      let ice = 0;
      let descuento = 0;
      let subtotalNoIva = 0;
      let subtotalExIva = 0;
      let subtotalIva0 = 0;
      let subtotalIva = 0;
      for (let i = 0; i < this.form.detalles.length; i++) {
        totalSinImpuestos += parseFloat(this.form.detalles[i].total_parcial);
        ice += parseFloat(this.form.detalles[i].ice);
        irbpnr += parseFloat(this.form.detalles[i].total_irbpnr);
        let desc = parseFloat(this.form.detalles[i].total_descuento);
        if (!isNaN(desc)) descuento += desc;
        if (this.form.detalles[i].id_iva === this.ivaNoObjeto)
          subtotalNoIva += parseFloat(this.form.detalles[i].total_parcial);
        if (this.form.detalles[i].id_iva === this.ivaExento)
          subtotalExIva += parseFloat(this.form.detalles[i].total_parcial);
        if (this.form.detalles[i].id_iva === this.ivaCero)
          subtotalIva0 += parseFloat(this.form.detalles[i].total_parcial);
        if (this.form.detalles[i].iva > 0)
          subtotalIva += parseFloat(this.form.detalles[i].total_parcial);
      }
      this.form.subtotal_iva_0 = round(subtotalIva0);
      this.form.subtotal_exento_iva = round(subtotalExIva);
      this.form.total_sin_impuestos = round(totalSinImpuestos);
      this.form.ice = round(ice);
      this.form.total_irbpnr = round(irbpnr);
      this.form.descuento_total = round(descuento);
      this.form.subtotal_no_sujeto_iva = round(subtotalNoIva);
      this.form.subtotal_iva = round(subtotalIva);
      let porcentajeIva = 0.15;
      let fecha_comprobante = this.form.fecha_emision;
      if(fecha_comprobante != '' && fecha_comprobante != null){
        if(moment(fecha_comprobante).isBefore('2024-04-01')) //Fecha de corte de IVA 15%
          porcentajeIva = 0.12;
      }
      iva = round(parseFloat(this.form.subtotal_iva) * porcentajeIva);
      this.form.iva = iva;
      this.form.total = round(
        round(totalSinImpuestos) + round(iva) + round(ice) + round(irbpnr)
      );
    },
    selectedComprobante: function(comprobante) {
      this.$modal.hide("listaComprobantes");
      this.selectedCliente = {
        id: comprobante.id_persona,
        nombre: comprobante.nombre_cliente,
        email: comprobante.correo_cliente
      };
      this.form.codigo_cliente = comprobante.id_persona;
      this.form.nombre_cliente = comprobante.nombre_cliente;
      this.form.email = comprobante.correo_cliente;
      if (comprobante.orden_trabajo != null) {
        this.orden_trabajo_id = comprobante.orden_trabajo.id;
        this.orden_trabajo =
          comprobante.orden_trabajo.tipo_documento +
          comprobante.orden_trabajo.numero_documento;
      } else {
        this.orden_trabajo_id = "";
        this.orden_trabajo = "";
      }
      this.form.mostrar_impuestos = comprobante.mostrar_impuestos === 'S';
      this.form.subtotal_exento_iva = comprobante.subtotal_exento_iva;
      this.form.subtotal_iva = comprobante.subtotal_iva;
      this.form.subtotal_iva_0 = comprobante.subtotal_iva_0;
      this.form.subtotal_no_sujeto_iva = comprobante.subtotal_no_iva;
      this.form.descuento_total = comprobante.total_descuento;
      this.form.total_sin_impuestos = comprobante.total_sin_impuestos;
      this.form.ice = comprobante.valor_ice;
      this.form.iva = comprobante.valor_iva;
      this.form.total_irbpnr = comprobante.valor_irbpnr;
      this.form.total = comprobante.valor_total;
      this.form.detalles.splice(0, this.form.detalles.length);
      this.selectedVendedor = null;
      this.form.observacion = comprobante.observacion;
      this.selectedPuntoEmision = null;
      this.form.formasPago = [];
      for (let i = 0; i < comprobante.formas_pago.length; i++)
        this.form.formasPago.push({
          plazo: comprobante.formas_pago[i].plazo,
          unidad_tiempo: comprobante.formas_pago[i].unidad_tiempo,
          valor: comprobante.formas_pago[i].total,
          selectedFormaPago: comprobante.formas_pago[i].forma_pago
        });
      if (this.clonProforma === null) {
        this.numero_comprobante =
          comprobante.codigo_establecimiento +
          "-" +
          comprobante.codigo_emisor +
          "-" +
          comprobante.numero_secuencial;
        this.estado = comprobante.id_estado_comprobante;
        this.facturada = comprobante.facturada;
        this.form.fecha_emision = moment(
          new Date(comprobante.fecha_emision)
        ).format("YYYY-MM-DD");
      } else this.numero_documento = "";
      if (this.clonProforma === null) {
        this.id_comprobante = comprobante.id_comprobante;
        this.numero_documento = comprobante.numero_proforma;
      }
      for (let i = 0; i < this.puntosEmision.length; i++) {
        if (
          this.puntosEmision[i].numero_secuencia ===
            comprobante.codigo_emisor &&
          this.puntosEmision[i].localidad.numero_localidad ===
            comprobante.codigo_establecimiento
        ) {
          this.selectedPuntoEmision = this.puntosEmision[i];
          break;
        }
      }
      for (let i = 0; i < this.vendedores.length; i++)
        if (this.vendedores[i].id == comprobante.vendedor_id) {
          this.selectedVendedor = this.vendedores[i];
          break;
        }
      this.form.informacionAdicional = [];
      for (let i = 0; i < comprobante.detalles_adicionales.length; i++)
        this.form.informacionAdicional.push({
          nombre_campo: comprobante.detalles_adicionales[i].nombre,
          valor_campo: comprobante.detalles_adicionales[i].valor,
          enviar_sri: comprobante.detalles_adicionales[i].enviar_sri === "S"
        });
      for (let i = 0; i < comprobante.items.length; i++) {
        let item = {
          cantidad: comprobante.items[i].cantidad,
          precio: comprobante.items[i].precio_unitario,
          total_descuento: comprobante.items[i].descuento,
          total_parcial: comprobante.items[i].precio_total_sin_imp,
          total_impuestos: 0,
          total: parseFloat(comprobante.items[i].precio_total_sin_imp),
          precio_produccion: comprobante.items[i].item.precio_produccion,
          irbpnr: comprobante.items[i].item.irbpnr === "S",
          total_irbpnr: 0,
          cantidad_ice: comprobante.items[i].item.cantidad_ice,
          cantidad_irbpnr: comprobante.items[i].item.cantidad_irbpnr,
          ice: 0,
          id_ice: "",
          detalle: "",
          valor_subsidio: comprobante.items[i].valor_subsidio,
          precio_sin_subsidio: comprobante.items[i].precio_sin_subsidio,
          selectedItem: comprobante.items[i].item,
          descripcion: comprobante.items[i].descripcion,
          mostrar_detalle: comprobante.items[i].mostrar_detalle === "S",
          selectedCategoria: comprobante.items[i].categoria,
          tipo_item: comprobante.items[i].tipo_item,
          observacion: "",
          coste: comprobante.items[i].coste
        };
        if (item.irbpnr)
          item.total_irbpnr =
            parseFloat(this.irbpnr) * parseFloat(item.cantidad);
        if (isNaN(item.total_irbpnr)) item.total_irbpnr = 0;
        for (let j = 0; j < comprobante.items[i].impuestos.length; j++) {
          if (
            comprobante.items[i].impuestos[j].id_impuesto === this.codigoIva
          ) {
            item.id_iva = comprobante.items[i].impuestos[j].id_tarifa;
            item.iva = comprobante.items[i].impuestos[j].valor;
            item.porcentaje_iva = comprobante.items[i].impuestos[j].porcentaje;
            item.selectedTarifa =
              comprobante.items[i].impuestos[j].tarifa_con_retencion;
          } else if (
            comprobante.items[i].impuestos[j].id_impuesto === this.codigoIce
          ) {
            item.id_ice = comprobante.items[i].impuestos[j].id_tarifa;
            item.ice = comprobante.items[i].impuestos[j].valor;
            item.porcentaje_ice = comprobante.items[i].impuestos[j].porcentaje;
            item.numero_unidades_ice =
              comprobante.items[i].item.numero_unidades_ice;
            item.tarifa_especifica_ice =
              comprobante.items[i].item.tarifa_especifica;
            item.porcentaje_ed_valorem =
              comprobante.items[i].item.porcentaje_ed_valorem;
          }
          let iva = parseFloat(item.iva);
          let ice = parseFloat(item.ice);
          item.total_impuestos +=
            (isNaN(iva) ? 0 : iva) + (isNaN(ice) ? 0 : ice) + item.total_irbpnr;
        }
        if (comprobante.items[i].detalles_adicionales.length > 0)
          item.observacion = comprobante.items[i].detalles_adicionales[0].valor;
        item.total += parseFloat(item.total_impuestos);
        this.form.detalles.push(item);
      }
      this.clonProforma = null;
    },
    enviarCorreo: function() {
      let that = this;
      axios
        .post(this.url + "/comprobantes/" + this.id_comprobante + "/correo")
        .then(function(response) {
          swal(
            "El comprobante ha sido enviado a la cola de envío de correos electrónicos.",
            "Aviso",
            "success"
          );
        })
        .catch(function(error) {
          if (error !== null && error !== undefined) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              let status = response.status;
              if (status === 404)
                swal(
                  "Se debe guardar el correo electrónico de la persona.",
                  "Aviso",
                  "warning"
                );
              else
                swal(
                  "Hubo un error al momento de realizar la opción seleccionada, intente nuevamente.",
                  "Error",
                  "error"
                );
            }
          }
        });
    },
    imprimirComprobante: function() {
      if (this.selectedPuntoEmision.punto_venta === "S")
        this.$modal.show("imprimir");
      else
        window.open(
          this.url + "/comprobantes/" + this.id_comprobante + "/ride",
          "_blank"
        );
    },
    guardarComprobante: function() {
      for (let i = 0; i < this.form.informacionAdicional.length; i++) {
        if (this.form.informacionAdicional[i].nombre_campo == 'Concepto' && (this.form.informacionAdicional[i].valor_campo == null || this.form.informacionAdicional[i].valor_campo == '')) {
          swal('Debe ingresar un concepto como información adicional.', 'Aviso', 'warning');
          return;
        }
      }
      this.errores = {};
      let that = this;
      let urlRequest = this.url + "/comprobantes/proforma";
      if (this.estado !== "N") {
        this.form._method = "PUT";
        urlRequest += "/" + this.id_comprobante;
      } else this.form._method = undefined;
      axios
        .post(urlRequest, this.form)
        .then(function(response) {
          that.id_comprobante = response.data.id_comprobante;
          that.numero_comprobante =
            response.data.codigo_establecimiento +
            "-" +
            response.data.codigo_emisor +
            "-" +
            response.data.numero_secuencial;
          that.estado = response.data.id_estado_comprobante;
          swal({
            title:
              "El comprobante fue almacenado con éxito. ¿Deseas imprimir el comprobante?",
            text: "Esta acción requiere de confirmación.",
            type: "question",
            showCancelButton: true,
            confirmButtonText: "Imprimir",
            cancelButtonText: "No"
          }).then(result => {
            if (result.value) that.imprimirComprobante();
          });
        })
        .catch(function(error) {
          if (error !== null && error !== undefined) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              if (response.status === 422) {
                that.errores = response.data.errors;
                swal("Hay errores de validación.", "Aviso", "warning");
              } else if (response.status === 403)
                swal(
                  "El punto de emisión manual ha llegado a su límite o ha expirado, por favor, actualice la secuencia del mismo.",
                  "Aviso",
                  "warning"
                );
              else if (response.status !== 404)
                swal("Hubo un error, intente nuevamente.", "Error", "error");
              else
                swal(
                  "Error de duplicidad, intente nuevamente.",
                  "Error",
                  "warning"
                );
            }
          }
        });
    },
    anularComprobante: function() {
      let that = this;
      swal({
        title: "¿Desea anular este comprobante?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Anular comprobante",
        cancelButtonText: "No"
      }).then(function(result) {
        if (result.value) {
          axios
            .post(
              that.url + "/comprobantes/" + that.id_comprobante + "/anular",
              {
                _method: "DELETE"
              }
            )
            .then(function(response) {
              that.estado = "A";
              swal("El comprobante ha sido anulado.", "Anulado", "success");
            });
        }
      });
    },
    nuevoComprobante: function() {
      swal({
        title: "¿Desear crear un nuevo comprobante?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Nuevo comprobante",
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) this.limpiar();
      });
    },
    limpiar: function() {
      this.orden_trabajo_id = "";
      this.orden_trabajo = "";
      this.form = {
        codigo_cliente: "",
        fecha_emision: moment(new Date()).format("YYYY-MM-DD"),
        id_punto_emision: "",
        formasPago: [],
        total_sin_impuestos: 0,
        descuento_total: 0,
        subtotal_no_sujeto_iva: 0,
        subtotal_exento_iva: 0,
        iva: 0,
        subtotal_iva: 0,
        subtotal_iva_0: 0,
        ice: 0,
        total: 0,
        informacionAdicional: [
          {
            nombre_campo: "Observación",
            valor_campo: "",
            enviar_sri: true
          },
          {
            nombre_campo: "Concepto",
            valor_campo: "",
            enviar_sri: true
          }
        ],
        detalles: [],
        total_irbpnr: 0,
        vendedor_id: "",
        email: "",
        nombre_cliente: "",
        observacion: ""
      };
      this.facturada = "N";
      this.numero_documento = "";
      this.clonProforma = null;
      this.errores = {};
      this.numero_comprobante = "";
      this.estado = "N";
      this.id_comprobante = "";
      this.selectedVendedor = null;
      this.selectedPuntoEmision = null;
      if (this.vendedores.length > 0) {
        this.ponerVendedorDefecto();
        this.inputVendedor();
      }
      if (this.puntosEmision.length > 0) {
        this.selectedPuntoEmision = this.puntosEmision[0];
        this.inputPuntoEmision();
      }
      this.selectedCliente = null;
    },
    consultarComprobantes: function() {
      this.$modal.show("listaComprobantes");
    },
    addTag: function(newTag) {
      const tag = {
        nombre: newTag,
        id:
          newTag.substring(0, 2).toUpperCase() +
          Math.floor(Math.random() * 10000000)
      };
      this.clientesTemp.push(tag);
      this.clientes.push(tag);
      this.selectedCliente = tag;
      this.inputCliente();
    },
    cargarDatos: function() {
      let that = this;
      axios
        .get(this.url + "/comprobantes/" + this.tipoDocumento + "/datos")
        .then(function(response) {
          let data = response.data;
          that.tarifas = data.tarifas;
          that.puntosEmision = data.puntosEmision;
          that.vendedores = data.vendedores;
          that.irbpnr = parseFloat(data.irbpnr.valor_tarifa);
          that.formasPago = data.formasPago;
          that.tiposUnidad = data.tiposUnidad;
          that.codigoIva = data.codigoIva;
          that.codigoIce = data.codigoIce;
          if (that.vendedores.length > 0) {
            that.ponerVendedorDefecto();
            that.inputVendedor();
          }
          if (that.puntosEmision.length > 0) {
            that.selectedPuntoEmision = that.puntosEmision[0];
            that.inputPuntoEmision();
          }
          let retencionProductos = parseFloat(data.retencion_productos);
          if (isNaN(retencionProductos)) retencionProductos = 0;
          that.retencion_productos = retencionProductos;
          let retencionServicios = parseFloat(data.retencion_servicios);
          if (isNaN(retencionServicios)) retencionServicios = 0;
          that.retencion_servicios = retencionServicios;
          if (that.clonProforma !== null)
            that.selectedComprobante(that.clonProforma);
          else if (that.comprobante !== null)
            that.selectedComprobante(that.comprobante);
        });
    }
  },
  mounted: function() {
    this.cargarDatos();
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/Proforma.vue